custom.Quickshop = (function () {
    var selectors = {
        product: '.grid-product',
        inventoryInfo: '.js-variant-inventory-info',
        holder: '.Quickshop--holder',
        overlay: '.Quickshop-overlay',
        dropdown: '.Quickshop-dropdown',
        list: '.Quickshop-list',
        toggle: '[data-quickshop-toggle]',
        trigger: '.collapsible-trigger',
        closeBtn: '.quickshop-close-btn',
        cartDrawer: {
            section: 'CartRecommendations-product-recommendations-cart',
            subsection: '#CartRecommendations-product-recommendations-cart [data-section-id]',
            inner: '#CartDrawer .drawer__inner'
        }
    };

    var config = {
        quickshop: 'Quickshop',
        open: 'is-open',
        state: 'quickshop--open',
        list: 'Quickshop-list',
        option: 'Quickshop-option',
        holder: {
            cart: 'holder--cart'
        },
        status: {
            loading: 'items--loading'
        }
    };

    var strings = {
        soldOut: theme.strings.soldOut,
        lowStock: custom.quickshop.settings.lowstockLabel
    };

    var status = {
        loading: false
    };

    function Quickshop() {
        this.products = document.querySelectorAll(selectors.product);
        this.settings = custom.quickshop.settings;

        this.init();
        this.initCart();
        this.collectionReloadInit();
    }

    Quickshop.prototype = Object.assign({}, Quickshop.prototype, {
        init: function () {
            this.products.forEach((product) => {
                var holder = product.querySelector(selectors.holder);
                var id = product.dataset.productId;

                if (holder) {
                    holder.addEventListener('click', () => {
                        if (!holder.classList.contains(config.quickshop)) {
                            holder.className = config.quickshop;

                            this._createInstance(product, holder, id);
                        }
                    });
                }
            });
        },

        initCart: function () {
            document.addEventListener('cart-recommendations:loaded', () => {
                var cartRec = document.getElementById(selectors.cartDrawer.section);
                this.products = cartRec.querySelectorAll(selectors.product);

                cartRec.querySelectorAll(selectors.holder).forEach((holder) => {
                    holder.setAttribute('data-role', config.holder.cart);
                });

                this.init.call(this);
            });
        },

        collectionReloadInit: function () {
            document.addEventListener('collection:reloaded', () => {
                new Quickshop;
            });
        },

        _createInstance: function (container, quickshop, id) {
            this.container = container;
            this.quickshop = quickshop;
            this.id = id;

            var toggle = quickshop.querySelector(selectors.toggle);
            var trigger = quickshop.querySelector(selectors.trigger);
            var dropdown = quickshop.querySelector(selectors.dropdown);

            var inventoryInfo = container.querySelector(selectors.inventoryInfo + ' div');
            var listEl = document.createElement('ul');

            this.dataset = inventoryInfo.dataset.variantInventory, this.dataset = JSON.parse(this.dataset);
            listEl.className = config.list, dropdown.appendChild(listEl);

            this.dataset.variants.forEach((variant) => {
                var optionEl = document.createElement('li');
                var qtyLimit = custom.quickshop.settings.quantityLimit;

                optionEl.className = config.option;
                optionEl.innerHTML = variant.title;
                optionEl.setAttribute('data-option-id', variant.id);
                optionEl.setAttribute('data-available', variant.available);

                if (variant.available) {
                    optionEl.setAttribute('data-lowstock', variant.quantity <= qtyLimit ? true : false);
                }

                listEl.appendChild(optionEl);
                this._addSelectedVariantAjax(variant, optionEl);
                this._checkAvailability(variant, optionEl, qtyLimit);
            });

            if (!this.dataset.has_only_default_variant) {
                var state = {
                    open: function () {
                        return this.setupOpen(quickshop, trigger, dropdown, listEl);
                    }.bind(this),

                    close: function () {
                        return this.setupClose(quickshop, trigger, dropdown);
                    }.bind(this)
                };

                toggle.addEventListener('click', () => {
                    !quickshop.classList.contains(config.open) ? state.open() : state.close();
                });

                container.addEventListener('mouseleave', state.close);
                [quickshop.querySelector(selectors.closeBtn), quickshop.querySelector(selectors.overlay)].forEach((el) => {
                    el.addEventListener('click', state.close);
                });

                state.open();
            }

            document.dispatchEvent(new CustomEvent('quickshop:build'));
        },

        setupOpen: function (target, trigger, dropdown, list) {
            if (!target.classList.contains(config.open)) {
                document.body.classList.add(config.state);
                [target, trigger].forEach((el) => {
                    el.classList.add(config.open);
                });

                dropdown.style.height = list.offsetHeight + 50 + 'px';
                target.setAttribute('aria-expanded', true);
            }
        },

        setupClose: function (target, trigger, dropdown) {
            if (target.classList.contains(config.open)) {
                document.body.classList.remove(config.state);
                [target, trigger].forEach((el) => {
                    el.classList.remove(config.open);
                });

                dropdown.style.height = '0px';
                target.setAttribute('aria-expanded', false);
            }
        },

        _addSelectedVariantAjax: function (option, target) {
            if (option.available) {
                var quantity = option.quantity;

                target.addEventListener('click', addToCart);

                if (this.dataset.has_only_default_variant) {
                    document.addEventListener('quickshop:build', addToCart);

                    this.quickshop.addEventListener('click', addToCart);
                }

                function addToCart() {
                    var formData = `${this.dataset}=${option.title}&id=${option.id}`;
                    var div = document.querySelector(selectors.cartDrawer.inner);

                    status.loading = true;
                    div.classList.add(config.status.loading);

                    fetch(theme.routes.cartAdd, {
                        method: 'POST',
                        body: formData,
                        credentials: 'same-origin',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    })
                        .then(response => response.json())
                        .then(function (data) {
                            if (data.status === 422) {
                                on.error(data);
                            } else {
                                on.success(data);
                            }
                        }.bind(this));

                    var on = {
                        success: function (data) {
                            var product = data;
                            var drawer = new theme.CartDrawer;

                            drawer.open();
                            updateQty();

                            updateCartRecommendations(), abort();
                            document.dispatchEvent(new CustomEvent('quickshop:added', {
                                detail: {
                                    product: product
                                }
                            }));
                        },

                        error: function (error) {
                            if (error.description && custom.quickshop.settings.errorMsg != null) {
                                alert(custom.quickshop.settings.errorMsg);
                            }

                            console.warn(error), abort();
                        }
                    };

                    function updateQty() {
                        var label = target.querySelector('span');

                        if (label && quantity > 0) {
                            quantity--;

                            label.textContent = label.textContent.replace(/[0-9]/, quantity);

                            switch (quantity) {
                                case 0:
                                    target.dataset.available = false;
                                    target.querySelector('span').textContent = strings.soldOut;
                                    break;
                                case 1:
                                    label.textContent = strings.lowStock.replace('[quantity]', quantity) + '!';
                                    break;
                            }
                        }
                    }

                    function abort() {
                        if (status.loading) {
                            status.loading = false;
                            div.classList.remove(config.status.loading);
                            document.body.classList.remove(config.state);

                            return;
                        }
                    }
                }

                updateCartRecommendations = function () {
                    var id = this.id;
                    var section = document.getElementById(selectors.cartDrawer.section);

                    if (!section || section.dataset.enable === 'false') {
                        return;
                    }

                    var subsection = document.querySelector(selectors.cartDrawer.subsection);

                    if (subsection.dataset.sectionId !== id) {
                        subsection.setAttribute('data-section-id', id);
                        theme.sections.register('product-recommendations-cart', theme.CartRecommendations);
                    }
                }.bind(this);
            }
        },

        _checkAvailability: function (variant, element, limit) {
            var quantity = variant.quantity;
            var isAvailable = variant.available;
            var lowStockLabel = strings.lowStock.replace('[quantity]', quantity);
            var placeholder;

            if (quantity > 1) {
                lowStockLabel = lowStockLabel.split(' ').slice(1).join(' ');
            } else {
                lowStockLabel = lowStockLabel + '!';
            }

            if (quantity <= limit && isAvailable) {
                placeholder = lowStockLabel;
            } else if (!isAvailable) {
                placeholder = strings.soldOut;
            }

            if (typeof placeholder !== 'undefined') {
                var labelOutput = `<span>${placeholder}</span>`;

                element.insertAdjacentHTML('beforeend', labelOutput);
            }
        }
    });

    return Quickshop;
})();

new custom.Quickshop;